<!--
 * @Description: 投诉建议
--> 
<template>
  <div class="meter-transfer-form">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.typeid"
        placeholder="类型"
      >
        <template #input>
          <van-radio-group v-model="form.typeid" direction="horizontal">
            <van-radio name="1" icon-size="12px">投诉</van-radio>
            <van-radio name="2" icon-size="12px">咨询</van-radio>
            <van-radio name="3" icon-size="12px">意见建议</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        v-model="form.subject"
        label="主题"
        placeholder="主题"
        :rules="[{ required: true, message: '请输入主题' }]"
      />
      <van-field
        required
        v-model="form.content"
        rows="2"
        autosize
        label="内容"
        type="textarea"
        maxlength="500"
        placeholder="请输入内容"
        show-word-limit
        :rules="[{ required: true, message: '请输入内容' }]"
      />
      <van-field
        required
        v-model="form.uname"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请输入姓名' }]"
      />
      <van-field
        required
        v-model="form.tel"
        label="电话"
        placeholder="电话"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      />
      <van-field
        required
        v-model="form.addr"
        label="地址"
        placeholder="地址"
        :rules="[{ required: true, message: '请输入地址' }]"
      />
      <van-field
        v-model="form.email"
        label="邮箱"
        placeholder="邮箱"
        :rules="[{pattern:$patternEmail,message:'请输入正确邮箱格式'}]"
      />
      <div class="comm-form-group">资料上传</div>
      <van-field
        name="uploaderZero"
        :rules="[{ required: true, message: '请上传资料' }]"
        >
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderZero"
            :after-read="afterReadMaster"
            @delete="onDeleteMaster"
            />
        </template>
      </van-field>
      <div v-if="!$route.query.readonly" style="margin:17px 16px;margin-bottom:36.5px;">
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          style="height:44px;"
          native-type="submit"
          >
          确认提交
        </van-button>
      </div>
    </van-form>
    <van-popup
      v-model="popShow"
      class="form-pop"
      >
      <div class="user-list" v-for="(user, i) in userList" :key="i">
        <user-item-select :user="user" @selectClick="onSelectClick"></user-item-select>
      </div>
    </van-popup>
  </div>
</template>

<script>
import UserItemSelect from '@/components/UserItemSelect.vue'
export default {
  name: 'AdviceForm',
  components: {
    UserItemSelect
  },
  data() {
    let cuser_info = null
    if(localStorage.getItem('cuser_info')){
      cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
    }
    return {
      popShow: false,
      // masterUrls: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      uploaderMst: [], // vant自带缩略图站位
      masterUrls: [],
      uploaderZero: [],
      zeroUrls: [],
      message: '',
      radio: '1',
      form: {
        typeid: '1', // 类型
        subject: '', // 主题
        content: '', // 内容
        uname: cuser_info?cuser_info.uname:'', // 姓名
        tel: cuser_info?cuser_info.mobile:'', // 电话
        addr: '', // 地址
        email: '',
        attach: []
      },
      disabled: false,
      mytime: 60000,
      value: '',
      showPicker: false,
      userList: JSON.parse(localStorage.getItem('userList'))
    }
  },
  mounted() {
    if(this.$route.query.busscode&&this.$route.query.bussno){
      this.$comm.getBussInfo(this.$route.query.busscode, this.$route.query.bussno).then(res => {
        this.form = res
        this.form.typeid = this.form.typeid?String(this.form.typeid): null
        let result = this.$comm.analysisAttach(res)
        this.uploaderZero = result.uploaderZero
        this.uploaderMst = result.uploaderMst
        this.uploaderHs = result.uploaderHs
        this.uploaderOpt = result.uploaderOpt
        this.zeroUrls = result.zeroUrls
        this.masterUrls = result.masterUrls
        this.hourseUrls = result.hourseUrls
        this.optUrls = result.optUrls
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'ButlerProgress') {
      to.meta.isUseCache = true
    }
    next()
  },
  methods: {
    validator(val) {
      if (val) {
        return this.$pattern.test(val);
      }
    },
    afterReadMaster (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.zeroUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    onDeleteMaster (file, detail) {
      this.zeroUrls.splice(detail.index, 1)
    },
    onSelectClick (user) {
      this.popShow = false
      this.form.userno = user.userno
      this.form.uname = user.uname
      this.form.addrold = user.addr
      this.form.fixaddr = user.fixaddr
    },
    choiceClick () {
      this.popShow = true
    },
    onSubmit() {
      this.form.attach = this.$comm.getAttach([], [], [], this.zeroUrls)
      let typeCode = this.$menuDict[this.$route.meta.title].typeCode
      this.$http.post(this.$api.serviceComplain, this.form).then(res => {
        if (res.code==='000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              typeCode: typeCode
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getAttachDict (attachUrls, typeId) {
      let attachDict = {}
      attachDict['typeid'] = typeId
      let attachUrl = ''
      for(let i=0;i<attachUrls.length;i++){
        if (i>0) {
          attachUrl = attachUrl + ',' + attachUrls[i].url
        } else{
          attachUrl = attachUrls[i].url
        }
      }
      attachDict['url'] = attachUrl
      return attachDict
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form{
  .form-pop{
    width:85%;
    height:60%;
    border-radius:4px;
    font-size:12px;
    .user-list{
      background:rgba(255,255,255,1);
      padding: 21px 16px;
    }
  }
}
</style>